module.exports = __webpack_public_path__ + "static/media/computer-classic.3b2e558d.svg";